export default __webpack_public_path__ + "static/media/meat-paperoni.8ed8ff3d.jpg";